import React from "react";
import Dialog, { DialogFooter, DialogHeader } from "../bootstrap/Dialog.jsx";
import { Portal } from "./Portal.jsx";

const ConfirmDialog = ({
  onClose,
  handleSubmit,
  disabled,
  title,
  addText,
  closeText,
  disabledText = I18n.t("loading"),
  footerDisabled,
  ...rest
}) => {
  const footer = (
    <DialogFooter
      onClose={onClose}
      onAdd={handleSubmit}
      closeText={closeText}
      addText={addText}
      disabled={disabled}
      disabledText={disabledText}
    />
  );
  const header = <DialogHeader onClose={onClose} title={title} />;

  return <Dialog footer={footerDisabled ? null : footer} header={header} {...rest} />;
};

const ConfirmDialogPortal = (props) => (
  <Portal component={ConfirmDialog} className="confirm-dialog" {...props} />
);

export default ConfirmDialogPortal;
